'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@sprd/sprd-component-kit/v2';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { ResponsiveDialog } from '@/components/ResponsiveDialog/ResponsiveDialog';
import { SizeGuide } from '@/components/Sizes/SizeGuide';
type SizeGuideDialogProps = {
  productType: ClientProductType;
  platform: Platform;
};
export const SizeGuideDialog = t0 => {
  const $ = _c(23);
  const {
    productType,
    platform
  } = t0;
  const t = useTranslations();
  const [openDialog, setOpenDialog] = useState(false);
  let t1;
  if ($[0] !== openDialog) {
    t1 = () => setOpenDialog(!openDialog);
    $[0] = openDialog;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("size.guide.title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <Button variant="plain" className="!p-0 !font-normal underline md:text-sm" onClick={t1}>{t2}</Button>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("size.guide.title");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("general.close");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = open => setOpenDialog(open);
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== platform || $[13] !== productType) {
    t7 = <SizeGuide className="px-4 py-4 text-sm sm:px-6 md:px-8 lg:px-10" productType={productType} platform={platform} sizeGuideIsInDialog={true} />;
    $[12] = platform;
    $[13] = productType;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== openDialog || $[16] !== t4 || $[17] !== t5 || $[18] !== t7) {
    t8 = <ResponsiveDialog dismissible={true} className="pb-12 md:max-w-1/2" open={openDialog} title={t4} closeLabel={t5} onOpenChange={t6}>{t7}</ResponsiveDialog>;
    $[15] = openDialog;
    $[16] = t4;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t3 || $[21] !== t8) {
    t9 = <div>{t3}{t8}</div>;
    $[20] = t3;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};